import { render } from "./ValuationItem.vue?vue&type=template&id=b0ce15cc"
import script from "./ValuationItem.vue?vue&type=script&lang=js"
export * from "./ValuationItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__